@if (isFormReadyToDisplay) {
  <form [formGroup]="form">
    @if (mapVisible) {
      <app-map-marker
        [mapVisible]="mapVisible"
        [mapDetails]="(mapDetails$ | async)"
        [latitude]="latitude"
        [longitude]="longitude"
        (doubleClickOnMap)="assignValuesOnDoubleClick($event)"
        (hideMapView)="hideMapView()"
        [mapHeader]="form?.value?.name || 'Mark Location'"
        [geoFencesForAsset]="(geoFencesForAsset$ | async)"
        (emitGeoFenceRadius)="updateGeoFenceRadius($event)"
        [showGeoFenceEdit]="showGeoFenceEdit"
      ></app-map-marker>
    }
    <div class="grid my-1">
      @for (field of formConfigData; track field) {
        <div class="form-group py-3 col-12 md:col-6 lg:col-6 xl:col-6"
             [ngClass]="{'hide': ((field?.linkedWith ? (form?.value?.[field?.linkedWith] !==  field?.toValue) : false) || field.type === 'hidden')}">
          @if ((field.type === 'text') || (field.type === 'email') || (field.type === 'preFill')) {
            <div
            >
              <!-- <mat-form-field color="accent" class="full-width" appearance="outline">
              <mat-label>{{field.label  | translate}}</mat-label>
              <input matInput type={{field.type}} placeholder="{{field.description | translate}}" formControlName={{field.field}} [required]="field.required">
            </mat-form-field> -->
              <p-floatlabel>
              <input type="{{field.type}}" class="full-width" id="basicInput" pInputText
                     [ngClass]="{'input-disable': (isFieldInvalid(field?.requiredField)) || (field.disabled && field.disabled === true)}"
                     (input)="handleInputChange($event,field?.isUnique,field.field);regexValidation($event?.target?.value,field?.regexValidation,field.field)"
                     formControlName={{field.field}} (change)="handleUppercaseCheck($event,field?.isUpperCase,field.field);resetValueIfNotValid(field)"
                     [required]="field.required">
              <label for="basicInput">{{ field.label | translate }} @if (field.required) {
                <span> *</span>
              }</label>
                @if (!valueExistMessage?.[field.field]?.['isUnique']) {
                  <small id="basicInput" class="smallErrorMsg">{{ valueExistMessage?.[field.field]?.isValueExistMessage }}</small>
                  }
                  @if (regexValidationObj && !regexValidationObj[field.field]) {
                  <small id="basicInput" class="smallErrorMsg">{{ field?.regexValidation?.message }}</small>
                }
            </p-floatlabel>
            </div>
          }
          @if (field.type === 'number') {
            <div class="number-field-div">
            <p-floatlabel><span class="full-width">
              <p-inputnumber styleClass="full-width pInputNumber" class="full-width pInputNumber"
                              formControlName={{field.field}}
                             mode="decimal" [showButtons]="true" [minFractionDigits]="2" [maxFractionDigits]="14"
                             inputId="minmax-buttons"
                             (onInput)="(field.field==='lat' || field.field==='lng') && onChange($event,field.field)"
              ></p-inputnumber>
              <label for="textarea">{{ field.label | translate }} @if (field.required) {
                <span> *</span>
              }</label>
            </span>
          </p-floatlabel>
              @if ((field.field === 'lat' || field.field === 'lng')) {
                <button pButton
                        pTooltip="Click to select from Map"
                        [tooltipPosition]="'bottom'"
                        (click)="mapVisible ? hideMapView() : showMapView()"
                        [disabled]="isEditForm ? !isEditOptionClicked : false"
                ><i class="pi pi-map-marker"></i></button>
              }
            </div>
          }
          @if (field.type === 'telephone') {
            <div>
              <p-floatlabel><span class="full-width">
                <p-inputNumber styleClass="full-width" class="full-width"
                                formControlName={{field.field}}
                               mode="decimal" inputId="withoutgrouping" [useGrouping]="false"></p-inputNumber>
                <label for="textarea">{{ field.label | translate }} @if (field.required) {
                  <span> *</span>
                }</label>
              </span>
            </p-floatlabel>
            </div>
          }
          <!--  -->
          @if (field.type === 'multiText') {
            <div>
              <p-floatlabel><span class="full-width">
                <p-autocomplete [multiple]="true" [typeahead]="false" styleClass="full-width" inputId="multiText" formControlName={{field.field}}
                          (onKeyUp)="validateRegexForMultiText(field);handleEmptyValues(field.field)"  [separator]="separatorExp" [unique]="false"/>
                         @if (regexValidationObj && !regexValidationObj[field.field]?.isValid) {
                          <small id="basicInput" class="smallErrorMsg">{{ field?.regexValidation?.message }}</small>
                        }
                <label for="multiText">{{ field.label | translate }} @if (field.required) {
                  <span> *</span>
                }</label>
              </span>
            </p-floatlabel>
            </div>
          }
          @if (field.type === 'textarea') {
            <div>
              <p-floatlabel><span class="full-width">
                <textarea pTextarea inputId="textarea" class="full-width" rows="3" cols="15"
                           formControlName={{field.field}}
                          [required]="field.required"
                          (change)="handleUppercaseCheck($event,field?.isUpperCase,field.field)"></textarea>
                <label for="textarea">{{ field.label | translate }} @if (field.required) {
                  <span> *</span>
                }</label>
              </span>
            </p-floatlabel>
            </div>
          }
          @if (field.type == 'date') {
            <div>
             
              <p-floatlabel><span class="full-width">
              <p-datepicker appendTo="body"  class="full-width" 
                          formControlName={{field.field}}></p-datepicker>
              <label>{{ field.label | translate }} @if (field.required) {
                <span> *</span>
              }</label>
            </span>
          </p-floatlabel>
            </div>
          }
          @if (field.type == 'dropDown' && !field?.isConditional) {
            <div>
            <p-floatlabel><span class="full-width">
              <p-select appendTo="body"  class="full-width TTC" inputId="drop_dropdown" [autoDisplayFirst]="false"
                (onChange)="handleGenericDropDownChange($event,field)" (onFilter)="handleDataFilterInDropDown($event,field)"
                          [filter]="true" filterBy="label"  formControlName={{field.field}}
                          [required]="field.required" [options]="field.dropDownValues" optionLabel="label" optionValue="value">
              </p-select>
              @if (!valueExistMessage?.[field.field]?.['isUnique']) {
              <small id="basicInput" class="smallErrorMsg">{{ valueExistMessage?.[field.field]?.isValueExistMessage }}</small>
              }
              <label class="full-width" for="drop_dropdown">{{ field.label | translate }} @if (field.required) {
                <span> *</span>
              }</label>
            </span>
          </p-floatlabel>
            </div>
          }
          @if (field.type == 'dropDown' && field?.isConditional && !field?.apiDetails?.searchAvailable &&
          form?.value?.[field?.linkedWith] === field?.toValue) {
            <div>
            <p-floatlabel><span class="full-width">
              <p-select appendTo="body"  class="full-width TTC" inputId="drop_dropdown" [autoDisplayFirst]="false"
                (onChange)="handleGenericDropDownChange($event,field)"
                          [filter]="true" filterBy="label"  formControlName={{field.field}}
                          [required]="field.required" [options]="field.dropDownValues" optionLabel="label" optionValue="value">
              </p-select>
              <label class="full-width" for="drop_dropdown">{{ field.label | translate }} @if (field.required) {
                <span> *</span>
              }</label>
            </span>
          </p-floatlabel>
            </div>
          }
          @if (field.type == 'multiSelect') {
            <div>
              <!-- <mat-form-field color="accent" class="full-width" appearance="outline">
              <mat-label>{{field.label  | translate}}</mat-label>
              <mat-select  [disableOptionCentering]="true" placeholder="{{field.description | translate}}" formControlName={{field.field}} [required]="field.required" multiple>
                <mat-option  *ngFor="let fieldData of field.dropDownValues" [value]="fieldData.value">{{fieldData.label  | translate}}</mat-option>
              </mat-select>
            </mat-form-field> -->
              <p-floatlabel><span class="full-width">
            <p-multiselect appendTo="body"  [options]="field.dropDownValues" inputId="multiSeldropdown" formControlName={{field.field}}
                           [filter]="true" filterBy="label" optionLabel="label" optionValue="value"
                            [required]="field.required">
            </p-multiselect>
            <label for="multiSeldropdown">{{ field.label | translate }} @if (field.required) {
              <span> *</span>
            }</label>
          </span>
        </p-floatlabel>
            </div>
          }
          @if (field.type == 'selectButton') {
          <div>
            <p-floatlabel><span class="full-width">
              <p-selectbutton unselectable="false" allowEmpty="false"  [options]="field.dropDownValues" formControlName={{field.field}}
                optionLabel="label" optionValue="value" [required]="field.required" />
              <label style="top: -0.75rem !important;">{{ field.label | translate }} @if (field.required) {<span>
                  *</span>}</label>
            </span>
          </p-floatlabel>
          </div>
          }
          @if (field.type == 'boolean') {
          <div>
            <span class="flex justify-content-between align-items-center gap-3">
              <label style="white-space: nowrap;color: #6c757d;">{{ field.label | translate }} @if (field.required) {
                <span> *</span>
                }</label>
              <p-toggleswitch class="full-width flex justify-content-start"
                [pTooltip]="field?.tooltipLabel[form?.value?.[field?.field]]?.Descripton"
                [formControlName]="field.field"></p-toggleswitch>
            </span>
          </div>
          }
          @if (field.type == 'colorPicker') {
            <div>
              <div class="form-group">
                <div style="display: flex;">
              <p-floatlabel>
                <input class="full-width" value={{foreColor.inputBgColor}}
                       required type="text" id="color-text" (change)="onColorChanged($event,field.field)" pInputText>
                <label for="color-text">{{ 'sys.color' | translate }}</label>
              </p-floatlabel>
                  <p-colorPicker class="full-width" formControlName={{field.field}} #foreColor></p-colorPicker>
                </div>
              </div>
            </div>
          }
          @if (field.type == 'array') {
            <div>
              <!-- <mat-form-field color="accent" class="full-width" appearance="outline">
              <mat-label>{{field.label | translate}}</mat-label>
              <textarea matInput placeholder="{{field.description | translate}}" formControlName={{field.field}} type={{field.type}} [required]="field.required"></textarea>
              <mat-hint align="start" class="redColorText">Enter the values with comma separated</mat-hint>
            </mat-form-field> -->
        <p-floatlabel><span class="full-width">
          <textarea pTextarea inputId="textarea" class="full-width" rows="3" cols="15"
             formControlName={{field.field}}
                    [required]="field.required"></textarea>
          <label for="textarea">{{ field.label | translate }} @if (field.required) {
            <span> *</span>
          }</label>
          <small id="textarea" class="">Enter the values with comma separated.</small>
        </span>
      </p-floatlabel>
      </div>
          }
          @if (field.type == 'accordian') {
            <div>
        <p-accordion [formGroupName]="field?.field">
          <p-accordion-panel [value]="field?.label">
            <p-accordion-header>{{field?.label | translate}}</p-accordion-header>
            <p-accordion-content>
            @for (accordian of field?.accordianData; track accordian) {
              <div>
                @if (accordian?.type == 'accordian') {
                  <div>
                    <p-accordion>
                      <p-accordion-panel [value]="accordian?.label">
                        <p-accordion-header>{{accordian?.label | translate}}</p-accordion-header>
                        <p-accordion-content>
                        <div [formGroupName]="accordian?.field">
                          @for (child of accordian?.childData; track child) {
                            <div>
                              <p-floatlabel><span class="mt-4">
                                <input class="full-width" id="basicInput" pInputText [formControlName]="child?.field"
                                        [required]="child.required">
                                <label for="basicInput">{{ child.label | translate }} @if (child.required) {
                                  <span> *</span>
                                }</label>
                              </span>
                            </p-floatlabel>
                            </div>
                          }
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                    </p-accordion>
                  </div>
                }
                @if (accordian?.type == 'text' || accordian?.type == 'password') {
                  <div>
                    <p-floatlabel><span class="mt-4">
                      <input class="full-width" type="{{accordian?.type}}" id="basicInput"
                              [formControlName]="accordian.field"
                             pInputText>
                      <label for="basicInput">{{ accordian.label | translate }} @if (accordian.required) {
                        <span> *</span>
                      }</label>
                    </span>
                  </p-floatlabel>
                  </div>
                }
                @if (accordian?.type == 'boolean') {
                  <div>
                    <span class="flex justify-content-between mt-4">
                      <label class="full-width"
                             for="basicInput">{{ accordian.label | translate }} @if (accordian.required) {
                        <span> *</span>
                      }</label>
                      <p-toggleswitch class="full-width flex justify-content-end"
                                     [formControlName]="accordian.field"></p-toggleswitch>
                    </span>
                  </div>
                }
                @if (accordian?.type == 'dropDown') {
                  <div>
                    <p-floatlabel><span class="full-width mt-4">
                      <p-select appendTo="body"  class="full-width TTC" inputId="drop_dropdown" [autoDisplayFirst]="false"
                      [filter]="true" filterBy="label"
                                  formControlName={{accordian.field}} [required]="accordian.required"
                                  [options]="accordian.dropDownValues" optionLabel="label" optionValue="value">
                      </p-select>
                      <label class="full-width"
                             for="drop_dropdown">{{ accordian.label | translate }} @if (accordian.required) {
                        <span> *</span>
                      }</label>
                    </span>
                  </p-floatlabel>
                  </div>
                }
              </div>
            }
          </p-accordion-content>
        </p-accordion-panel>
        </p-accordion>
      </div>
          }
        </div>
      }
    </div>
    <!--  -->
    <div class="grid my-1" [ngClass]="{ 'kiosk-add-More-details-form': isKioskAddMoreDetailsForm}">
      @if (!isKioskAddMoreDetailsForm) {
        <div class="col-6" style="display: flex;">
          @if (formConfigData?.length > 0 && !isCloneBtnReq && showUpdateBtn) {
            <p-button class="MR10" [disabled]="checkSubmitBtnDisableStatus()"
                      (onClick)="submitConfigDetails()">
              @if (isEditForm) {
                <span>{{ 'sys.update' | translate }}</span>
              }
              @if (!isEditForm) {
                <span>{{ 'sys.submit' | translate }}</span>
              }
            </p-button>
          }
      <!-- Submit Button in Clone Form -->
          @if (formConfigData?.length > 0 && isCloneBtnReq && showUpdateBtn && !isEditForm) {
            <p-button class="MR10" (onClick)="submitConfigDetails()"
                      [disabled]="checkSubmitBtnDisableStatus()">
              <span>{{ 'sys.submit' | translate }}</span>
            </p-button>
          }
          <!-- Clone Button in Clone Form -->
          @if (formConfigData?.length > 0 && isCloneBtnReq && showUpdateBtn && isEditForm) {
            <p-button class="MR10" (onClick)="submitConfigDetails()">
              <span pTooltip="Create a copy" tooltipPosition="top">{{ 'sys.clone' | translate }}</span>
            </p-button>
          }
          @if (formConfigData?.length > 0 && isCloneBtnReq && isEditForm) {
            <p class="btn-hint"> This is created by other user, you can't edit </p>
          }
      <!-- <p-button color="warn" class='buttonEnable' [disabled]="!isEditOptionClicked" [class.showDeregisterAssetPopupBtn]="isEditOptionClicked"
    *ngIf="showDeRegisterBtn" (onClick)="deregisterSelectedAsset()">{{'sys.de-register' | translate}}</p-button> -->
          <p-confirmPopup key="eventFormPopup"></p-confirmPopup>
          @if (showDeRegisterBtn) {
      <p-button  pButton type="button" label="{{'sys.remove' | translate}}"
        class="buttonEnable remove-button" [outlined]="true" severity="danger"
              (click)="deregisterSelectedAsset($event)"/>
          }
        </div>
      }
      <!-- Next Button Container for Kiosk Add More Details Form -->
      <ng-container *ngTemplateOutlet="kioskAddMoreDetailsFormTemplate"></ng-container>
    </div>
</form>
}

@if (showCircularLoader) {
  <div>
    <app-circular-loader></app-circular-loader>
  </div>
}





<ng-template #kioskAddMoreDetailsFormTemplate>
  @if (isKioskAddMoreDetailsForm) {
    <div class="col-6 mx-2" style="display: flex;">
      <button (click)="submitConfigDetails()" pButton
              iconPos="right" icon="pi pi-arrow-right"
              [disabled]="checkSubmitBtnDisableStatus()"
              label="Next" styleClass="mr-3 mb-3"></button>
    </div>
  }
</ng-template>
